import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=3551af52&"
import script from "./Fields.vue?vue&type=script&lang=ts&"
export * from "./Fields.vue?vue&type=script&lang=ts&"
import style0 from "./Fields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports